// extracted by mini-css-extract-plugin
module.exports = {"container":"FamDocInfoConfirmDialogStyles_container__1ZAu7","text":"FamDocInfoConfirmDialogStyles_text__3hITQ","buttons":"FamDocInfoConfirmDialogStyles_buttons__16gOA"};